import { createActions } from 'redux-actions';

import types from 'state/errors/actionTypes';

const { errors } = createActions({
  [types.SET_ERROR]: (errs = {}) => ({ errors: errs }),
  [types.REMOVE_ERROR]: (errs = []) => ({ errors: errs }),
  [types.CLEAN_ERRORS]: () => ({}),
});

export default errors;
